export const getAstronautMenuOptions = (
  isEngineer: boolean,
  isDiagnosticPageActive: boolean,
  isUpdatesPageActive: boolean,
): any[] => {
  return [
    {
      menuTitle: 'overview',
      iconClass: 'lely-icon-activities',
      appendixUrl: 'astronaut/overview',
    },

    {
      menuTitle: 'diagnostics',
      iconClass: 'lely-icon-reports',
      appendixUrl: 'astronaut/domains/canbus',
      featureFlag: isDiagnosticPageActive,
    },
    {
      menuTitle: 'dataExplorer',
      iconClass: 'lely-icon-graph-view',
      appendixUrl: 'astronaut/data-explorer',
      overviewParam: true,
    },
    {
      menuTitle: 'events',
      iconClass: 'lely-icon-tasks',
      appendixUrl: 'astronaut/events',
    },
    {
      menuTitle: 'logs',
      iconClass: 'lely-icon-table',
      appendixUrl: 'astronaut/logs',
      featureFlag: isEngineer,
    },
    {
      menuTitle: 'settings',
      iconClass: 'lely-icon-settings',
      appendixUrl: 'astronaut/settings',
    },
    {
      menuTitle: 'updates',
      iconClass: 'lely-icon-update',
      appendixUrl: 'astronaut/updates',
      featureFlag: isUpdatesPageActive,
    },
  ];
};

export const getVectorMenuOptions = (): any[] => {
  return [
    {
      menuTitle: 'dataExplorer',
      iconClass: 'lely-icon-graph-view',
      appendixUrl: 'vector/data-explorer',
    },
    {
      menuTitle: 'performanceIndicators',
      iconClass: 'lely-icon-graph',
      appendixUrl: 'vector/performance-indicators',
    },
    {
      menuTitle: 'events',
      iconClass: 'lely-icon-tasks',
      appendixUrl: 'vector/events',
    },
  ];
};

export const AMF_MENU_OPTIONS = [
  {
    menuTitle: 'settings',
    iconClass: 'lely-icon-settings',
    appendixUrl: 'amf/settings',
  },
];

export const DISCOVERY_MENU_OPTIONS = [
  {
    menuTitle: 'logs',
    iconClass: 'lely-icon-table',
    appendixUrl: 'discovery/logs',
  },
];

export const isPageActive = (urlPageName, appendixUrl) => {
  if (urlPageName === appendixUrl) {
    return true;
  }
  if (urlPageName.includes(appendixUrl)) {
    return true;
  }
  if (appendixUrl.includes(urlPageName)) {
    return true;
  }
  return false;
};

type LanguageCode = string;

const languageSupport = {
  hr: { vector: true, astronaut: true },
  cs: { vector: true, astronaut: true },
  da: { vector: true, astronaut: true },
  nl: { vector: true, astronaut: true },
  en: { vector: true, astronaut: true },
  et: { vector: true, astronaut: true },
  fi: { vector: true, astronaut: true },
  fr: { vector: true, astronaut: true },
  de: { vector: true, astronaut: true },
  el: { vector: true, astronaut: true },
  he: { vector: false, astronaut: true },
  hu: { vector: false, astronaut: true },
  is: { vector: true, astronaut: true },
  it: { vector: true, astronaut: true },
  ja: { vector: true, astronaut: true },
  ko: { vector: true, astronaut: true },
  lv: { vector: true, astronaut: true },
  lt: { vector: true, astronaut: true },
  no: { vector: true, astronaut: true },
  pl: { vector: true, astronaut: true },
  pt: { vector: true, astronaut: true },
  ro: { vector: true, astronaut: true },
  ru: { vector: true, astronaut: true },
  sk: { vector: false, astronaut: true },
  sl: { vector: true, astronaut: true },
  es: { vector: true, astronaut: true },
  sr: { vector: false, astronaut: true },
  sv: { vector: true, astronaut: true },
  tr: { vector: true, astronaut: true },
  zh: { vector: false, astronaut: true },
};

export const getLanguageImpactMessage = (
  language: LanguageCode,
): string | null => {
  const support = languageSupport[language];

  if (!support) return null; // or a default message

  if (support.vector && support.astronaut) {
    return 'The selected language impacts the translation of Astronaut and Vector alarm text only. English will be used for the rest of the application text.';
  }
  if (support.vector && !support.astronaut) {
    return 'The selected language impacts the translation of Vector alarm text only. English will be used for the rest of the application text.';
  }
  if (!support.vector && support.astronaut) {
    return 'The selected language impacts the translation of Astronaut alarm text only. English will be used for the rest of the application text.';
  }
  return null;
};
